import React from "react";
import { Link, NavLink } from "react-router-dom";

const HeadButtons = () => {
  return (
    <>
      <div className="text-center">
        <button className="custom_btn my-2">
          <NavLink exact to="/" activeClassName="menu_active" className="linkClass">All</NavLink>
        </button>
        <button className="custom_btn my-2">
        <NavLink to="/psd" activeClassName="menu_active" className="linkClass">PSD</NavLink>
        </button>
        <button className="custom_btn my-2">
        <NavLink to="/responsive" activeClassName="menu_active" className="linkClass">Responsive</NavLink>
        </button>
        <button className="custom_btn my-2">
        <NavLink to="/react" activeClassName="menu_active" className="linkClass">React.js</NavLink>
        </button>
        <button className="custom_btn my-2">
        <NavLink to="/next" activeClassName="menu_active" className="linkClass">Next.js</NavLink>
        </button>
        <button className="custom_btn my-2">
        <NavLink to="/mern" activeClassName="menu_active" className="linkClass">MERN Stack</NavLink>
        </button>
        <button className="custom_btn my-2">
        <NavLink to="/python" activeClassName="menu_active" className="linkClass">Python</NavLink>
        </button>
      </div>
    </>
  );
};

export default HeadButtons;
